import { Navigate, useLocation } from "react-router-dom";
import { useApiToken } from "@/components/providers/token-provider";
import { Loader2 } from "lucide-react";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isTokenLoaded, isAuthenticated } = useApiToken();
  const location = useLocation();

  // Show loading state while checking authentication
  if (!isTokenLoaded) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        role="status"
        aria-live="polite"
        aria-label="Loading"
      >
        <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden />
      </div>
    );
  }

  // Redirect to login if not authenticated, preserving the intended destination and org param
  if (!isAuthenticated) {
    const search = location.search;
    return <Navigate to={`/login${search}`} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
